(function() {
  const track = document.getElementById('sliderTrack');
  if (!track) return;
  let currentSlide = 0;
  const slides = track.querySelectorAll('img');
  const totalSlides = slides.length;
  const dots = document.querySelectorAll('.gallery-dot');

  function updateSlider() {
    track.style.transform = `translateX(-${currentSlide * 100}%)`;
    dots.forEach((d, i) => {
      d.className = i === currentSlide ? 'gallery-dot w-2.5 h-2.5 rounded-full bg-cyan transition' : 'gallery-dot w-2.5 h-2.5 rounded-full bg-slate3 hover:bg-slate4 transition';
    });
  }
  window.slideGallery = function(dir) {
    currentSlide = (currentSlide + dir + totalSlides) % totalSlides;
    updateSlider();
  };
  window.goToSlide = function(idx) {
    currentSlide = idx;
    updateSlider();
  };
  let touchStartX = 0;
  track.addEventListener('touchstart', e => {
    touchStartX = e.touches[0].clientX;
  });
  track.addEventListener('touchend', e => {
    const diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) slideGallery(diff > 0 ? 1 : -1);
  });
})();
(function() {
  const track = document.getElementById('sliderTrack');
  const lightbox = document.getElementById('lightbox');
  const lbImg = document.getElementById('lightboxImg');
  const lbCounter = document.getElementById('lightboxCounter');
  if (!track || !lightbox || !lbImg || !lbCounter) return;
  const slides = track.querySelectorAll('img');
  const totalSlides = slides.length;
  const lbDots = document.querySelectorAll('.lb-dot');
  const images = Array.from(slides).map(img => img.src);
  let lbIndex = 0;

  function updateLightbox() {
    lbImg.src = images[lbIndex];
    lbCounter.textContent = `${lbIndex + 1} / ${totalSlides}`;
    lbDots.forEach((d, i) => {
      d.className = i === lbIndex ? 'lb-dot w-2 h-2 rounded-full bg-cyan transition' : 'lb-dot w-2 h-2 rounded-full bg-slate3 transition';
    });
  }
  window.openLightbox = function(idx) {
    lbIndex = idx;
    updateLightbox();
    lightbox.classList.remove('hidden');
    lightbox.classList.add('flex');
    document.body.style.overflow = 'hidden';
  };
  window.closeLightbox = function() {
    lightbox.classList.add('hidden');
    lightbox.classList.remove('flex');
    document.body.style.overflow = '';
  };
  window.slideLightbox = function(dir) {
    lbIndex = (lbIndex + dir + totalSlides) % totalSlides;
    updateLightbox();
  };
  window.goToLightbox = function(idx) {
    lbIndex = idx;
    updateLightbox();
  };
  lightbox.addEventListener('click', e => {
    if (e.target === lightbox) closeLightbox();
  });
  document.addEventListener('keydown', e => {
    if (lightbox.classList.contains('hidden')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') slideLightbox(-1);
    if (e.key === 'ArrowRight') slideLightbox(1);
  });
  let lbTouchStartX = 0,
    lbTouchStartY = 0;
  lightbox.addEventListener('touchstart', e => {
    lbTouchStartX = e.touches[0].clientX;
    lbTouchStartY = e.touches[0].clientY;
  });
  lightbox.addEventListener('touchend', e => {
    const diffX = lbTouchStartX - e.changedTouches[0].clientX;
    const diffY = lbTouchStartY - e.changedTouches[0].clientY;
    if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
      slideLightbox(diffX > 0 ? 1 : -1);
    } else if (diffY < -80) {
      closeLightbox();
    }
  });
})();
(function() {
  const reviewSlider = document.getElementById('reviewSlider');
  const reviewSliderImg = document.getElementById('reviewSliderImg');
  const reviewCounter = document.getElementById('reviewCounter');
  const reviewUser = document.getElementById('reviewUser');
  const reviewStars = document.getElementById('reviewStars');
  const reviewImages = document.querySelectorAll('#reviews .grid img');
  if (!reviewSlider || !reviewSliderImg || !reviewCounter || !reviewUser || !reviewStars || !reviewImages.length) return;
  let reviewIdx = 0;
  const totalReviews = reviewImages.length;

  function updateReviewSlider() {
    const img = reviewImages[reviewIdx];
    reviewSliderImg.src = img.src;
    reviewCounter.textContent = `${reviewIdx + 1} / ${totalReviews}`;
    reviewUser.textContent = img.dataset.user || '';
    const rating = parseInt(img.dataset.rating, 10) || 0;
    reviewStars.innerHTML = Array(5).fill(0).map((_, i) => `
																					<i class="fas fa-star ${i < rating ? 'text-cyan' : 'text-slate3'}">
																					</i>`).join('');
  }
  window.openReviewSlider = function(idx) {
    reviewIdx = idx;
    updateReviewSlider();
    reviewSlider.classList.remove('hidden');
    reviewSlider.classList.add('flex');
    document.body.style.overflow = 'hidden';
  };
  window.closeReviewSlider = function() {
    reviewSlider.classList.add('hidden');
    reviewSlider.classList.remove('flex');
    document.body.style.overflow = '';
  };
  window.slideReview = function(dir) {
    reviewIdx = (reviewIdx + dir + totalReviews) % totalReviews;
    updateReviewSlider();
  };
  reviewSlider.addEventListener('click', e => {
    if (e.target === reviewSlider) closeReviewSlider();
  });
  document.addEventListener('keydown', e => {
    if (reviewSlider.classList.contains('hidden')) return;
    if (e.key === 'Escape') closeReviewSlider();
    if (e.key === 'ArrowLeft') slideReview(-1);
    if (e.key === 'ArrowRight') slideReview(1);
  });
  let rsTouchX = 0,
    rsTouchY = 0;
  reviewSlider.addEventListener('touchstart', e => {
    rsTouchX = e.touches[0].clientX;
    rsTouchY = e.touches[0].clientY;
  });
  reviewSlider.addEventListener('touchend', e => {
    const dx = rsTouchX - e.changedTouches[0].clientX;
    const dy = rsTouchY - e.changedTouches[0].clientY;
    if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 50) slideReview(dx > 0 ? 1 : -1);
    else if (dy < -80) closeReviewSlider();
  });
})();
let openFaqIndex = -1;

function toggleFaq(idx) {
  const answer = document.getElementById('faqAnswer' + idx);
  const icon = document.getElementById('faqIcon' + idx);
  if (!answer || !icon) return;
  if (openFaqIndex === idx) {
    answer.classList.add('hidden');
    icon.classList.remove('rotate-45');
    openFaqIndex = -1;
  } else {
    if (openFaqIndex >= 0) {
      const prevAnswer = document.getElementById('faqAnswer' + openFaqIndex);
      const prevIcon = document.getElementById('faqIcon' + openFaqIndex);
      if (prevAnswer) prevAnswer.classList.add('hidden');
      if (prevIcon) prevIcon.classList.remove('rotate-45');
    }
    answer.classList.remove('hidden');
    icon.classList.add('rotate-45');
    openFaqIndex = idx;
  }
}
